import { useMutation } from '@tanstack/react-query';

import { analyzeReceipt } from '../services/receipts';
import type { ReceiptAnalysisResults } from '../types/receipt/receipt';

/**
 * Convert File to base64 data URL
 */
async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export interface UseReceiptAnalysisParams {
  receiptFile: File;
}

/**
 * Converts file to base64 and calls Fiona AI service
 */
export function useReceiptAnalysis() {
  return useMutation<ReceiptAnalysisResults, Error, UseReceiptAnalysisParams>({
    mutationFn: async ({ receiptFile }) => {
      // Convert file to base64
      const base64Data = await fileToBase64(receiptFile);

      // Call analysis endpoint with image data
      return await analyzeReceipt(base64Data, receiptFile.type);
    },
  });
}
